import { downloadBlob } from './downloadBlob';

const MIME_MAP: Record<string, string> = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  csv: 'text/csv',
  pdf: 'application/pdf',
  zip: 'application/zip',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

/**
 * Decodes a base64-encoded file content string and triggers a browser download.
 *
 * Use this when the API returns a JSON response with a base64 `content` field
 * (common pattern across Wealthlane export/download endpoints).
 */
export function downloadBase64File(base64Content: string, fileName: string): void {
  const byteCharacters = atob(base64Content);
  const byteNumbers = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  const blob = new Blob([byteNumbers], {
    type: MIME_MAP[extension] ?? 'application/octet-stream',
  });
  downloadBlob({ data: blob, defaultFileName: fileName });
}
